export interface TreeItem<T> {
  item: T;
  expanded: boolean;
  loaded: false;
  children: null | TreeItem<T>[] | Promise<void>;
}

export const depthSequence: { row: string }[] = [
  { row: "row-0" },
  { row: "row-1" },
  { row: "row-2" },
  { row: "row-3" },
  { row: "row-4" },
  { row: "row-5" },
  { row: "row-6" },
  { row: "row-7" },
  { row: "row-8" },
  { row: "row-9" },
];
